import React, { Component } from "react";
import { Helmet } from "react-helmet";

import ProfileFormAddresses from "../profileFormAddresses/ProfileFormAddresses";
import ProfileFormEmployment from "../profileFormEmployment/ProfileFormEmployment";

import "./profileFormHistory.css";
export default class ProfileFormHistory extends Component {
  render() {
    return (
      <div className="profile-form-history">
        <Helmet>
          <title>{`Profile | History`}</title>
        </Helmet>
        <ProfileFormEmployment />
        <hr />
        <ProfileFormAddresses />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/profileFormHistory/ProfileFormHistory.js